exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".px-3{padding:15px;-webkit-box-sizing:border-box;box-sizing:border-box}", ""]);

